import React from 'react';
import Form, { Actions, Password, RequiredValidator } from '../../../Components/Form';

const PasswordChallenge = ({ onSubmit }) => {
    return <Form onSubmit={onSubmit}>
        <Password label="Password" name="password" validators={[RequiredValidator]} />
        <Actions
            submit={{label: 'Log in'}}
        />
    </Form>;
};

export default PasswordChallenge;
